/* Front-only controls for Maytrix's five optical-illusion product models. */
(() => {
  const namePattern = /maytrix-(octagon|circle|square|hexagon|triangle)-deep(?:[._-]|\.glb)/i;
  const settings = {
    'camera-controls':'', 'disable-pan':'', 'disable-tap':'', 'disable-zoom':'',
    'camera-target':'0m 0m 0m',
    'min-camera-orbit':'-8deg 85deg 0.9m', 'max-camera-orbit':'8deg 95deg 0.9m',
    'field-of-view':'35deg', 'min-field-of-view':'35deg', 'max-field-of-view':'35deg',
    'interaction-prompt':'none', 'exposure':'1.1', 'shadow-intensity':'0', 'tone-mapping':'neutral'
  };
  const sources = new WeakMap();
  function selected(viewer) {
    const slide=viewer.closest('[data-product-photo]');
    return !slide || slide.classList.contains('is-selected') || (!slide.closest('.flickity-enabled') && slide.classList.contains('starting-slide'));
  }
  function activate(viewer) {
    if(!viewer || !viewer.hasAttribute('data-maytrix-deep-illusion')) return;
    viewer.setAttribute('loading','eager');
    viewer.setAttribute('reveal','auto');
    viewer.dismissPoster?.();
    const button=viewer.closest('[data-product-media-type-model]')?.querySelector('.shopify-model-viewer-ui__button--poster');
    if(button && viewer.classList.contains('shopify-model-viewer-ui__disabled')) button.click();
  }
  document.addEventListener('mediaVisible',event=>{
    const viewer=event.target.querySelector?.('model-viewer[data-maytrix-deep-illusion]');
    if(!viewer) return;
    // This theme sends mediaVisible without detail; handle these five viewers here.
    event.stopImmediatePropagation();
    activate(viewer);
  },true);
  function apply(viewer) {
    if (!viewer.matches?.('model-viewer')) return;
    const src = viewer.getAttribute('src') || '';
    if (!namePattern.test(src) && !viewer.hasAttribute('data-maytrix-deep-illusion')) return;
    const shape = viewer.dataset.maytrixShape || namePattern.exec(src)?.[1] || 'circle';
    const orbit = shape === 'octagon' ? '7deg 90deg 0.9m' : (shape === 'triangle' ? '-3deg 90deg 0.9m' : '-7deg 90deg 0.9m');
    viewer.dataset.maytrixDeepIllusion = 'true';
    for (const [key,value] of Object.entries({...settings, ...(shape === 'triangle' ? {'min-camera-orbit':'-4deg 88deg 0.9m','max-camera-orbit':'4deg 92deg 0.9m'} : {})})) if (viewer.getAttribute(key) !== value) viewer.setAttribute(key,value);
    viewer.removeAttribute('auto-rotate'); viewer.removeAttribute('ar');
    viewer.style.backgroundColor = '#030305'; viewer.style.setProperty('--poster-color','#030305');
    const gallery = viewer.closest('[data-product-single-media-group]');
    if (gallery) {
      gallery.dataset.maytrixLockedGallery = 'true';
      gallery.querySelectorAll('[data-shopify-xr]').forEach(button => {button.hidden=true;button.style.setProperty('display','none','important');});
    }
    const customPoster = viewer.dataset.maytrixPoster;
    if (customPoster && viewer.getAttribute('poster') !== customPoster) viewer.setAttribute('poster',customPoster);
    const id = viewer.dataset.modelId;
    if (id && /^\d+$/.test(id)) {
      document.querySelectorAll('[data-product-thumb][data-id="'+id+'"], [data-maytrix-media-id="'+id+'"]').forEach(thumb => {
        thumb.classList.add('maytrix-model-thumb'); thumb.setAttribute('aria-label','View '+shape+' mirror in 3D');
        const img=thumb.querySelector('img'), poster=viewer.getAttribute('poster');
        if(img && poster && img.getAttribute('src') !== poster) {img.setAttribute('src',poster);img.setAttribute('srcset',poster);}
      });
    }
    if(selected(viewer)) activate(viewer);
    if (sources.get(viewer) === src) return;
    sources.set(viewer,src); viewer.setAttribute('camera-orbit',orbit);
    const record = () => {
      const current=viewer.getCameraOrbit?.();
      if(current) viewer.dataset.maytrixOrbit=JSON.stringify({theta:current.theta*180/Math.PI,phi:current.phi*180/Math.PI,radius:current.radius});
    };
    viewer.addEventListener('camera-change',record);
    viewer.addEventListener('load',()=>{
      viewer.resetTurntableRotation?.(); viewer.cameraOrbit=orbit; viewer.jumpCameraToGoal?.();
      viewer.dataset.maytrixModelLoaded='true'; record();
    },{once:true});
  }
  function scan(root) {
    if(root.matches?.('model-viewer')) apply(root);
    root.querySelectorAll?.('model-viewer').forEach(apply);
  }
  scan(document);
  new MutationObserver(records => {
    for(const record of records) {
      if(record.type === 'attributes') apply(record.target);
      else record.addedNodes.forEach(node=>{if(node.nodeType===1)scan(node);});
      const container=record.target.closest?.('[data-product-photo]');
      const viewer=container?.querySelector('model-viewer[data-maytrix-deep-illusion]');
      if(viewer && selected(viewer)) activate(viewer);
    }
  }).observe(document.documentElement,{subtree:true,childList:true,attributes:true,attributeFilter:['class','src','ar','auto-rotate','camera-target','min-camera-orbit','max-camera-orbit','field-of-view','min-field-of-view','max-field-of-view','disable-pan','disable-tap','disable-zoom']});
  document.addEventListener('shopify:section:load',event=>scan(event.target));
})();
